<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button autoHide="true" data-cy="myPairedLenders-hdr-menuBtn"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="myPairedLender-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>

      <ion-button *ngIf="!offlineMode" (click)="openHelp()" data-cy="myPairedLender-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineMode" (click)="common.openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline-outline"></ion-icon>
      </ion-button>

    </ion-buttons>
    <ion-title data-cy="myPairedLender-hdr-title">Paired Lender</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>

  <div class="myPairedLenders" *ngIf="showLenders">

    <div class="spacer-20"></div>

    <div class="agentsDiv mainContentBox">

      <div class="spacer-20"></div>

      <div class="pairDivHeader" data-cy="myPairedLender-agents-title">Paired Lender</div>
      <div class="spacer-10"></div>

      <div *ngFor="let lender of myPairedLenders; let i = index" class="agentComponent borderBox">

        <app-public-profile-item [showControls]="true" [showSocial]="true" [attr.data-index]="i" class="listing-item"
          [user]="lender">
        </app-public-profile-item>

      </div>

      <div class="alreadyConnectedWarning" *ngIf="alreadyConnected">
        <p>Since you're already paired with a lender, you'll need to unpair the existing lender before pairing a new
          lender. <strong class="link" (click)="learnMore()"> Learn more</strong></p>
      </div>
      <div class="spacer-20"></div>
    </div>

  </div>

  <div class="myPairedLenders" *ngIf="!alreadyConnected">

    <div class="spacer-20"></div>
    <app-floating-paired-item *ngIf="!loading" [noResultsMessage]="'Enter a lender\'s email to invite them'"
      type="lender" />

    <div class="spacer-10"></div>

    <!-- ALGOLIA VIEW  -->
    <div class="agentsDiv mainContentBox">

      <!-- RECOMMENDED LENDER -->
      <div>
        <div class="spacer-10"></div>

        <div class="pairDivHeader">

          <ion-label>Recommended Lenders</ion-label>

          <!-- CURRENT ZIP CODE VIEW -->
          <div class="link zipCodeDiv grey-message-area" *ngIf="currentLocationView === 'currentZipCodeView'"
            (click)="enterLocation()">

            <ion-icon name="location-outline"></ion-icon>

            <span class="zip" data-cy="myPairedAgents-location-enteredZipCode">{{userZipcode}}</span>

          </div>
        </div>

        <div class="spacer-20"></div>

        <div *ngIf="myPairedLendersInvites.length" [ngClass]="algoliaLoading ? 'hide' : ''">

          <div *ngFor="let inviteObj of myPairedLendersInvites; let i = index" class="agentComponent borderBox fadeIn">

            <app-public-profile-item [showControls]="true" [showSocial]="true" [attr.data-index]="i"
              class="listing-item" [user]="inviteObj" [showContact]="false" [showInvite]="true">
            </app-public-profile-item>

          </div>
        </div>

        <!-- ENTER LOCATION-->
        <div class="noAgentsDiv blockBox centerBox centerAlign" *ngIf="currentLocationView === 'enterZipCodeView'">

          <p class="infoText" data-cy="myPairedAgents-location-title">
            Enter your location to see nearby lenders using Curb Hero</p>

          <img src="/assets/imgs/addLenderZipCode.png" data-cy="myPairedAgents-location-icon" />

          <p class="helpText" data-cy="myPairedAgents-location-description">Pair with nearby lenders using Curb Hero.
            <br /><strong class="link" (click)="learnMore(3)">Learn More</strong>
          </p>

          <div class="full-width centerAlign">

            <ion-button style="width:94%; max-width: 350px;" (click)="enterLocation()"
              data-cy="myPairedAgents-location-enterLocationBtn">Enter Location</ion-button>

          </div>
        </div>

        <algolia-automatic-search [style.display]="currentLocationView !== 'enterZipCodeView' ? 'block' : 'none'"
          #algoliaAutomaticLenderSearch [instanceName]="instanceName"
          noResultsMessage="No more recommended lenders found" [filterHitsFn]="filterHitsFn"
          [childComponent]="hitTemplate" />

        <ng-template #hitTemplate let-hit>
          <app-public-profile-item [pairedAgentData]="hit" [showControls]="false" [showContact]="false"
            [showSocial]="true" [showInvite]="true" [searchInviteMode]="false" (inviteClicked)="inviteClickedFn(hit)" />
        </ng-template>
      </div>
    </div>

    <div class="spacer-20"></div>

  </div>

  <!-- <div *ngIf="loading" class="skeleton-holder">
    <div class="loadingDiv blockBox centerBox centerAlign">
      <ion-label>Loading</ion-label>
      <div class="padding">
        <ion-spinner name="crescent"></ion-spinner>
      </div>
    </div>
  </div> -->

</ion-content>